export const cashLocationTypeValues = ['drawer', 'vault', 'treasury'] as const;
export type CashLocationType = (typeof cashLocationTypeValues)[number];

export const cashLocationStatusValues = ['active', 'disabled'] as const;
export type CashLocationStatus = (typeof cashLocationStatusValues)[number];

export const cashConfigProvenanceValues = ['cloud', 'local'] as const;
export type CashConfigProvenance = (typeof cashConfigProvenanceValues)[number];

export interface CashLocationDto {
  id: string;
  companyId: string;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  name: string;
  type: CashLocationType;
  status: CashLocationStatus;
  provenance: CashConfigProvenance;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashLocationRequest {
  companyId: string;
  operationId: string;
  occurredAt?: string;
  name: string;
  type: CashLocationType;
  storeId?: string;
  locationId?: string;
  stationId?: string;
}

export interface CreateCashLocationResponse {
  cashLocation: CashLocationDto;
}

export interface ListCashLocationsRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  type?: CashLocationType;
  status?: CashLocationStatus;
}

export interface ListCashLocationsResponse {
  items: CashLocationDto[];
}

export interface DisableCashLocationRequest {
  companyId: string;
  cashLocationId: string;
  operationId: string;
  occurredAt?: string;
}

export interface DisableCashLocationResponse {
  cashLocation: CashLocationDto;
}
